import React, { useEffect } from 'react';
import './referandearn.css';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import Upperbox from '../components/Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';
const Referandearn = () => {

    useEffect(() => {
    // Scroll to the top when the page is loaded
    window.scrollTo(0, 0);
  }, []);

  
  return (
    <div>
     
      <NavBar />

     

   <div className="refer-and-earn-container">
  <h2 className="refer-and-earn-title">Refer & Earn with Litax</h2>

  <div className="refer-info">
    <p>
      Invite your friends, family, or colleagues to file their taxes with <strong>Litax</strong> and earn exciting rewards for every successful referral.
    </p>
    <p>
      Already have an account? Simply log in and submit your referrals directly.  
      New here? <a href="/signup">Create your account</a> in just a minute and start earning right away while tracking your referral status in real-time.
    </p>
    <button className="refer-btn" onClick={() => window.location.href='/signup'}>
      Start Referring
    </button>
  </div>

  <div className="referral-bonus-structure">
    <h3>💰 How the Bonus Works</h3>
    <ul>
      <li><strong>1 - 10 Referrals:</strong> Earn <span>$10</span> per referral</li>
      <li><strong>11 - 20 Referrals:</strong> Earn <span>$15</span> per referral</li>
      <li><strong>21+ Referrals:</strong> Earn <span>$20</span> per referral</li>
    </ul>
  </div>

  <div className="referral-bonus-policy">
    <h3>📌 Important Policy</h3>
    <p>
      Your referral bonus can be used to reduce your tax filing fees. If your bonus exceeds your fees, the remaining balance will be credited to your bank account after <strong>April 25th</strong>.
    </p>
    <p>
      <span className="note">Note:</span> Bonuses are credited only after your referred person completes their tax filing payment.  
      This program is valid only for referrals submitted through the <em>"Refer a Friend"</em> page and does not apply to verbal or offline referrals.
    </p>
  </div>
</div>

      <Cosection/>
      <Whatsapp/>
      <ScrollTop/>
      <Footer />
    </div>
  );
};

export default Referandearn;
